import { Component } from 'react';
import styles from './PageParent.scss';

export default class PageParent extends Component {

    render(){
        const { children } = this.props;

        return (
            <section className={styles.PageParent} data-cy="PageParent">
                { children }
            </section>
        );
    }
}